import { Avatar, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { stringToHslColor } from '../../services/Utils';
import SmsIcon from '@mui/icons-material/Sms';

export const AssistantAvatar = () => {
    const theme = useTheme();
    return (
        <Grid>
            <SmsIcon sx={{
                color: theme.palette.primary[600],
                fontSize: '35px',
            }} />
        </Grid>
    );
}

export const UserAvatar = ({ userName }) => {
    return (
        <Grid>
            <Avatar
                sx={{
                    position: 'inherit',
                    width: '33px',
                    height: '33px',
                    fontSize: '1rem',
                    bgcolor: stringToHslColor(userName, 40, 40),
                }}
            >
                {userName?.charAt(0).toUpperCase()}
            </Avatar>
        </Grid>
    );
}